// GENERATED FILE - DO NOT EDIT.
// Source: backend/tests/snapshots/openapi_contract.json, via `npm run gen:api` (orval).
// Regenerate after the API contract changes; `npm run check:gen-api` fails when this is stale.
import * as zod from 'zod';
import { CountryTag } from './countryTag.zod.ts';
import { ExpertOut } from './expertOut.zod.ts';
import { Freshness } from './freshness.zod.ts';
import { MaterialOut } from './materialOut.zod.ts';
import { MyRefinement } from './myRefinement.zod.ts';
import { ProofOut } from './proofOut.zod.ts';
import { RelationOut } from './relationOut.zod.ts';
import { SectionOut } from './sectionOut.zod.ts';
import { Tag } from './tag.zod.ts';

export const AssetOut = zod.object({
  "countries": zod.array(CountryTag),
  "created_at": zod.iso.datetime({"offset":true}),
  "experts": zod.array(ExpertOut),
  "freshness": Freshness,
  "home_country": zod.string(),
  "id": zod.uuid(),
  "industries": zod.array(Tag),
  "kind": zod.string(),
  "materials": zod.array(MaterialOut),
  "maturity": zod.string(),
  "my_refinement": zod.union([MyRefinement,zod.null()]),
  "name": zod.string(),
  "partners": zod.array(Tag),
  "proof": ProofOut,
  "publish_missing": zod.union([zod.array(zod.string()),zod.null()]),
  "published_at": zod.union([zod.iso.datetime({"offset":true}),zod.null()]),
  "relations": zod.array(RelationOut),
  "revision": zod.int(),
  "sections": zod.array(SectionOut),
  "status": zod.string(),
  "summary": zod.string(),
  "tagline": zod.string(),
  "updated_at": zod.iso.datetime({"offset":true})
});

export type AssetOut = zod.input<typeof AssetOut>;
export type AssetOutOutput = zod.output<typeof AssetOut>;
